import styled from "styled-components";

import { media } from "constants/media";
export const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;

    > p {
        display: none;
    }

    ${media.lgUp} {
        > p {
            display: inline;
            padding-right: 16px;
        }
    }
`;

export const List = styled.div`
    column-gap: 16px;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;

    white-space: nowrap;

    ::-webkit-scrollbar {
        display: none;
    }
`;
export const ListItem = styled.button<{ isActive: boolean }>`
    background: none;
    background-color: ${({ isActive }) =>
        isActive ? "var(--color-green-40)" : ""};
    border: 1px solid
        ${({ isActive }) =>
            isActive ? "var(--color-green-40)" : "var(--color-beige-60)"};
    color: ${({ isActive }) =>
        isActive ? "var(--color-beige-40)" : "var(--color-green-40)"};
    cursor: pointer;
    padding: 0 4px;
`;
